import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["ariaLabel", "className", "focusable", "height", "role", "viewBox", "width"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { ICON_SIZE } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";

var createIconWithPath = function createIconWithPath(paths) {
  var CreateIconWithPath = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var ariaLabel = _ref.ariaLabel,
        className = _ref.className,
        focusable = _ref.focusable,
        height = _ref.height,
        role = _ref.role,
        viewBox = _ref.viewBox,
        width = _ref.width,
        other = _objectWithoutProperties(_ref, _excluded);

    var ariaAttrs = {};

    if (ariaLabel) {
      ariaAttrs['aria-label'] = ariaLabel;
    }

    return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread(_objectSpread({
      xmlns: "http://www.w3.org/2000/svg",
      className: className,
      tabIndex: focusable ? 0 : undefined,
      focusable: focusable,
      height: height,
      ref: ref,
      role: role,
      viewBox: viewBox,
      width: width
    }, ariaAttrs), other), {}, {
      children: paths.map(function (path) {
        return /*#__PURE__*/_jsx("path", _objectSpread({}, path), path.d);
      })
    }));
  });
  CreateIconWithPath.propTypes = {
    /** Adds aria label for icon */
    ariaLabel: PropTypes.node,

    /** Adds classname to the icon */
    className: PropTypes.string,

    /** Sets if icon is focusable when using tab */
    focusable: PropTypes.bool,

    /** Sets the height of the icon */
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /** Sets the role of the icon */
    role: PropTypes.string,

    /** Sets icon viewbox */
    viewBox: PropTypes.string,

    /** Sets the width of the icon */
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };
  CreateIconWithPath.defaultProps = {
    ariaLabel: '',
    className: '',
    focusable: false,
    height: ICON_SIZE.DEFAULT,
    role: 'presentation',
    viewBox: '0 0 24 24',
    width: ICON_SIZE.DEFAULT
  };
  return CreateIconWithPath;
};

export { createIconWithPath };